module.exports = __webpack_public_path__ + "static/media/logo-pmf.cd519caa.png";